import React from "react";
import { Outlet } from "react-router-dom";

export const BulkSparesPage = () => {
  return <Outlet />;
};
